<template>
    <fieldset class="people-counter">
        <div class="people-counter-select">
            <template v-for="(item, index) in items">
                <input type="radio" :id="uuid(index)" name="rating" :value="item.value" :checked="hasChecked(index)"
                       @change="change($event)">
                <label class="touchable" :for="uuid(index)" :title="item.title || ''">{{ item.title || '' }}</label>
            </template>
        </div>
        <div class="people-counter-value">{{ value }}</div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => ([])
            },
            value: {
                type: Number,
                default: -1
            }
        },

        data() {
            return {
                selected: this.value
            }
        },

        methods: {
            uuid(index) {
                return `people-counter-${this._uid}-item-${index}`
            },

            hasChecked(index) {
                return this.count - index === this.selected
            },

            change(e) {
                this.selected = e.target.value >>> 0
                this.$emit('change', this.selected)
            }
        },

        computed: {
            count() {
                return this.items.length
            }
        }
    }
</script>

<style lang="scss">
    $icon-count: 3;
    $mobile-icon-size: 50px;
    $desktop-icon-size: 80px;

    .people-counter-select {
        display: inline-block;
        position: relative;
        width: $icon-count * $mobile-icon-size;
        height: $mobile-icon-size;
        padding: 0;
        border: none;

        @media (min-width: 580px) {
            width: $icon-count * $desktop-icon-size;
            height: $desktop-icon-size;
        }

        > input {
            position: absolute;
            margin-right: -100%;
            opacity: 0;
        }

        > input:checked ~ label,
        > input:focus ~ label {
            background-image: url('/images/rate-selected.svg');
        }

        > input:hover ~ label {
            background-image: url('/images/rate-selected.svg');
        }

        > label {
            float: right;
            position: relative;
            width: $mobile-icon-size;
            height: $mobile-icon-size;
            display: inline-block;
            margin: 0;
            color: transparent;
            cursor: pointer;
            background-image: url('/images/rate-unselected.svg');
            background-repeat: no-repeat;
            background-size: contain;

            @media (min-width: 580px) {
                width: $desktop-icon-size;
                height: $desktop-icon-size;
            }
        }
    }

    .people-counter-value {
        display: inline-block;
        height: $mobile-icon-size;
        vertical-align: middle;

        @media (min-width: 580px) {
            height: $desktop-icon-size;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PeopleCounter.vue